import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import PrintSidebar from '../PrintSidebar';
import useWindowLocationHref from '../Hooks/useWindowLocation';

const Share = ({ ShareChannels, Translations, PrintsideBarEnabled }) => {
  if (!ShareChannels) return null;
  const href = useWindowLocationHref();

  return (
    <div className="c-share show-for-large">
      <h2 className="c-share__heading">{Translations && Translations.share}</h2>
      <ul className="c-share__list">
        {ShareChannels.map((item, key) => {
          const shareChannelClass = classNames({
            'c-share__icon': true,
            [`c-share__icon--${item.Channel}`]: true,
          });

          return (
            <li key={key} className="c-share__list__item">
              {item.Channel !== 'mailto' ? (
                <button
                  data-event-category={href || 'novalue'}
                  data-event-action={Translations.copylink}
                  data-event-value={href || 'novalue'}
                  data-event-name={Translations.copylink}
                  className="c-share__list__item__share-btn"
                  type="button"
                  title={Translations && Translations.copylink}
                  onClick={() => {
                    navigator.clipboard.writeText(item.ShareURL);
                  }}
                >
                  <span data-event-include className={shareChannelClass} />
                  <span className="show-for-sr">
                    {Translations && Translations.copylink}
                  </span>
                </button>
              ) : (
                <button
                  data-event-category={href || 'novalue'}
                  data-event-action={Translations.tipafriend}
                  data-event-value={href || 'novalue'}
                  data-event-name={Translations.tipafriend}
                  type="button"
                  className="c-share__list__item__share-btn"
                  title={Translations && Translations.tipafriend}
                  onClick={() => {
                    if (typeof window !== 'undefined') {
                      window.location.href = item.ShareURL;
                    }
                  }}
                >
                  <span data-event-include className={shareChannelClass} />
                  <span className="show-for-sr">
                    {Translations && Translations.tipafriend}
                  </span>
                </button>
              )}
            </li>
          );
        })}
        <li className="c-share__list__item">
          {PrintsideBarEnabled ? (
            <PrintSidebar
              ShareChannels={ShareChannels}
              Translations={Translations}
            />
          ) : (
            <button
              data-event-category={href || 'novalue'}
              data-event-action={Translations.print}
              data-event-value={href || 'novalue'}
              data-event-name={Translations.print}
              className="c-share__list__item__share-btn"
              type="button"
              onClick={() => {
                window.print();
              }}
              title={Translations && Translations.print}
            >
              <span
                data-event-include
                className="c-share__icon c-share__icon--print"
              />
              <span className="show-for-sr">
                {Translations && Translations.print}
              </span>
            </button>
          )}
        </li>
      </ul>
    </div>
  );
};

Share.propTypes = {
  ShareChannels: PropTypes.array,
  Translations: PropTypes.object,
  PrintsideBarEnabled: PropTypes.bool,
};

export default Share;
